// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/andong-katuri/Katuri.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/quest/ox_quiz_bubble.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/quest/ox_bg_1280x800.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/quest/ox_bg_1920x1200.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/quest/ox_answer_o.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/quest/ox_answer_x.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/quest/quiz_animal_toucan.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * OX 퀴즈 러너 스타일 — 가로 태블릿. 주렁주렁 숲/그린 세계관.
 * 모든 클래스는 .ox-runner 하위로 스코프(다른 화면과 충돌 방지).
 */

@font-face {
  font-family: 'Katuri';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
  font-style: normal;
  font-weight: 400;
  font-display: swap;
}

.ox-runner {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
  padding: 16px 8px;
}

.ox-runner .ox-btn {
  border: none;
  border-radius: 24px;
  cursor: pointer;
  font-weight: 800;
}

/* ── 설정 오류(문항 없음) ── */
.ox-runner-error {
  text-align: center;
}

.ox-runner .ox-error-icon {
  font-size: 56px;
}

.ox-runner .ox-error-text {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #b91c1c;
}

.ox-runner .ox-btn-cancel {
  background: #059669;
  color: #fff;
  padding: 12px 28px;
  font-size: 18px;
  border-radius: 12px;
}

/* ══ OX 퀴즈 문항 화면 — Figma 3510:48255 (2026-08-12 취득) ══
   🔴 **개정됐다.** 이전(Figma 1966:43897)은 나무판 배경 + 상단 제목/구분선/진행표시 +
      440px O/X 대형 패널 + 좌하단 동물이었다. 개정본은 베이지 그라데이션 위에
      제목 한 줄 · 문제 · **문항 첨부 이미지** · 하단 작은 OX 두 개뿐이다.
      폐기한 선택자: .ox-quiz-top · -head · -kicker · -title · -body · -divider · -progress ·
      -question · -panels · -panel-o · -panel-x · -animal · -animal-clip
      ⚠️ 이 줄에 \`panel-*\` 처럼 별표+슬래시가 붙으면 **주석이 조기 종료**돼 바로 아래
         \`.ox-quiz\` 규칙이 통째로 파싱에서 탈락한다(2026-08-12 실측: 브라우저 규칙 27개 중
         \`.ox-quiz\` 없음 → --quiz-u 미정의 → 좌표 전멸). CSS 원문 grep 가드는 못 잡는다.

   원본 프레임 1920x1200. 좌표는 --quiz-u(vw 환산)로 잡는다 — 이 화면은 1280×800 과
   1920×1200 두 해상도를 함께 쓴다. 크기 조절은 --quiz-scale 한 줄.

   🔴 배경(베이지 그라데이션)은 \`.oxq-screen-beige\`(OxQuizFlow.css)를 **공유**한다 —
      화면 ②와 같은 값이라 두 군데 적으면 갈린다. 그래서 러너도 그 CSS 를 import 한다. */
.ox-quiz {
  --quiz-scale: 1; /* 글자 크기 조절 손잡이. 1 = Figma 원본 */
  --quiz-u: calc(100vw / 1920 * var(--quiz-scale)); /* Figma 1px */

  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: 'GosanjaOTF', 'Katuri', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* 말풍선 — Figma Union 3756:36611. 몸통 사각형 x70 y70 1780×306 + 꼬리 x1492 y376 80×80.
   🔴 좌표는 **몸통이 아니라 자산 상자** 기준이다. 내보낸 SVG 는 드롭섀도가 사방으로
      번져 1860×454.702 이고, 피그마 배치값(inset 좌우 -2.25% / 위 -4.27% / 아래 -17.08%)을
      역산하면 몸통보다 좌우 40 · 위 16 · 아래 64 만큼 크다 → x30 y54 에 놓아야 몸통이
      제자리에 온다. 몸통 좌표(70,70)에 그대로 놓으면 말풍선이 우하단으로 40px 밀린다.
   🔴 옛 상단 고정 문구(.ox-quiz-heading)는 **이 말풍선으로 대체됐다** — 개정 노드에 그
      텍스트 자리가 없다. 되살리면 그 자리(y60~125)가 문제 상자(y120~)와 겹친다. */
.ox-quiz .ox-quiz-bubble {
  position: absolute;
  left: calc(30 * var(--quiz-u));
  top: calc(54 * var(--quiz-u));
  width: calc(1860 * var(--quiz-u));
  height: calc(454.702 * var(--quiz-u));
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / contain;
  pointer-events: none;
}

/* 문제 — Figma 텍스트 x170 y120, 1580×206, 86px #6e4417 중앙정렬 (3756:36615).
   바깥 프레임이 x120 폭 1680 에 좌우 패딩 50 이라 글자 상자는 x170 폭 1580 이다.
   🔴 \`Q.\` 접두는 없어졌다(개정 디자인 문구에 없다).
   🔴 글자 크기 72 는 Figma 원본 86 을 **낮춘 값**이다(2026-08-18 사용자 결정). 86 으로 그리면
      실제 등록 문항이 상자를 넘어 자동 줄바꿈이 일어나고, 관리자가 의도한 줄 수가 어긋난다
      (실측: '훔볼트 팽귄은…' 1830.5 > 1580). 72 에서 현재 전 문항이 약 3% 여유로 들어간다.
      🔴 이 값은 **상한이기도 하다** — 더 긴 문항은 JS(\`fitPromptFontSize\`)가 더 줄인다.
         상수 4개(폭·높이·상한·줄간격)는 JS 와 짝이며 테스트가 일치를 강제한다.
   🔴 높이 206 은 Figma 값 그대로다. 72 기준 두 줄(172.8)은 담고 세 줄(259.2)은 담지 못한다 —
      세로 중앙정렬이라 1줄이면 가운데 한 줄, 2줄이면 위아래로 고르게 놓인다.
   🔴 \`pre-line\` 이 줄바꿈을 살린다. 빠지면 개행이 공백 한 칸으로 접혀 한 줄로 붙는다
      (JS 의 normalizeQuestionText 와 짝 — 한쪽만 있으면 줄바꿈이 화면에 안 나온다).
   🔴 \`keep-all\` 은 피그마 내보내기(break-word)와 다르게 **일부러 유지**한다 — 한글을
      어절 중간에서 끊으면 가독성이 떨어진다. 줄 나눔은 관리자가 넣은 개행으로 통제한다. */
.ox-quiz .ox-quiz-prompt {
  position: absolute;
  left: calc(170 * var(--quiz-u));
  top: calc(120 * var(--quiz-u));
  width: calc(1580 * var(--quiz-u));
  height: calc(206 * var(--quiz-u));
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: calc(72 * var(--quiz-u));
  line-height: 1.2;
  color: #6e4417;
  text-align: center;
  white-space: pre-line;
  word-break: keep-all;
}

/* 문항 첨부 이미지 — Figma x420 y424, 1080×600.
   \`object-fit: contain\` 이라 관리자가 올린 이미지 비율이 달라도 잘리지 않는다.
   🔴 이미지가 없는 레거시 문항에서는 이 요소 자체를 렌더하지 않는다(R8). */
.ox-quiz .ox-quiz-image {
  position: absolute;
  left: calc(420 * var(--quiz-u));
  top: calc(424 * var(--quiz-u));
  width: calc(1080 * var(--quiz-u));
  height: calc(600 * var(--quiz-u));
  object-fit: contain;
}

/* 마무리 화면 배경 — OX 스캔 대기 화면과 동일한 '숲' 그림(픽셀 대조 확인) */
.ox-quiz-done {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@media (min-width: 1600px) {
  .ox-quiz-done {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }
}

/* 마무리 화면 동물 — Figma 2295:75892: 좌측 720x880 상자(세로 중앙), 안쪽 680x780 */
.ox-quiz .ox-quiz-done-animal {
  position: absolute;
  left: 4.1667%; /* 80/1920 */
  top: 50%;
  transform: translateY(-50%);
  width: 37.5%; /* 720/1920 */
  height: 73.3333%; /* 880/1200 */
  z-index: 1;
}

.ox-quiz .ox-quiz-done-animal-clip {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 94.4444%; /* 680/720 */
  height: 88.6364%; /* 780/880 */
  overflow: hidden;
}

/* 하단 O/X — Figma 3510:48255 의 \`OX\`(x860 y1044, 200×96)를 **좌=O · 우=X 2버튼**으로 쪼갰다
   (사용자 확정 R5). 원본 자산의 글리프 실측: O = x6~727 / X = x809~1494 → 표시 중심은
   O(909, 1092) · X(1014, 1092).

   🔴 **히트박스는 시각보다 넓다.** 글리프는 96px 인데 버튼 상자는 200px 이다 —
      어린이가 누르는 화면이라 보이는 크기로만 잡으면 헛터치가 난다.
      \`background-size\` 로 그림만 원래 크기로 그리고 상자는 크게 둔다.
   🔴 중앙정렬은 음수 마진으로 — transform 은 연출 애니메이션과 충돌한다(2026-07-31 사고). */
.ox-quiz .ox-quiz-answers {
  position: absolute;
  inset: 0;
}

.ox-quiz .ox-quiz-answer {
  position: absolute;
  top: calc(1092 * var(--quiz-u));
  width: calc(200 * var(--quiz-u));
  height: calc(200 * var(--quiz-u));
  margin: calc(-100 * var(--quiz-u)) 0 0 calc(-100 * var(--quiz-u));
  padding: 0;
  border: none;
  background: transparent no-repeat center;
  cursor: pointer;
  transition: transform 0.08s ease-out, filter 0.08s ease-out;
}

.ox-quiz .ox-quiz-answer-o {
  left: calc(909 * var(--quiz-u));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: calc(96 * var(--quiz-u)) auto;
}

.ox-quiz .ox-quiz-answer-x {
  left: calc(1014 * var(--quiz-u));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: calc(91 * var(--quiz-u)) auto;
}

.ox-quiz .ox-quiz-answer:active:not(:disabled) {
  transform: scale(0.9);
}

.ox-quiz .ox-quiz-answer:disabled {
  cursor: default;
  filter: grayscale(0.35) brightness(0.92);
}

/* 마무리 화면 동물 이미지 — \`.ox-quiz-done-animal-clip\` 안에서 쓴다.
   ⚠️ 문항 화면의 좌하단 동물(\`.ox-quiz-animal\`/\`-clip\`)은 개정 디자인에 없어 폐기했다. */
.ox-quiz .ox-quiz-animal-img {
  position: absolute;
  left: -8.05%;
  top: -14.54%;
  width: 113.24%;
  height: 123.84%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center / 100% 100%;
}

`, "",{"version":3,"sources":["webpack://./src/components/quest/OxQuizRunner.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,qBAAqB;EACrB,+DAA0E;EAC1E,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;6DAc6D;AAC7D;EACE,eAAe,EAAE,+BAA+B;EAChD,gDAAgD,EAAE,cAAc;;EAEhE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,8FAA8F;AAChG;;AAEA;;;;;;0DAM0D;AAC1D;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,6BAA6B;EAC7B,iCAAiC;EACjC,qCAAqC;EACrC,8EAAmF;EACnF,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;uDAauD;AACvD;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,iCAAiC;EACjC,iCAAiC;EACjC,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;gDAEgD;AAChD;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,iCAAiC;EACjC,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,yDAA+D;AACjE;;AAEA;EACE;IACE,yDAAgE;EAClE;AACF;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,aAAa,EAAE,YAAY;EAC3B,QAAQ;EACR,2BAA2B;EAC3B,YAAY,EAAE,aAAa;EAC3B,gBAAgB,EAAE,aAAa;EAC/B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,eAAe,EAAE,YAAY;EAC7B,gBAAgB,EAAE,YAAY;EAC9B,gBAAgB;AAClB;;AAEA;;;;;;;kEAOkE;AAClE;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,iCAAiC;EACjC,iEAAiE;EACjE,UAAU;EACV,YAAY;EACZ,wCAAwC;EACxC,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,+BAA+B;EAC/B,yDAA4D;EAC5D,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,yDAA4D;EAC5D,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;kEACkE;AAClE;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gFAA0F;AAC5F","sourcesContent":["/**\n * OX 퀴즈 러너 스타일 — 가로 태블릿. 주렁주렁 숲/그린 세계관.\n * 모든 클래스는 .ox-runner 하위로 스코프(다른 화면과 충돌 방지).\n */\n\n@font-face {\n  font-family: 'Katuri';\n  src: url('../../assets/fonts/andong-katuri/Katuri.otf') format('opentype');\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n}\n\n.ox-runner {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 28px;\n  padding: 16px 8px;\n}\n\n.ox-runner .ox-btn {\n  border: none;\n  border-radius: 24px;\n  cursor: pointer;\n  font-weight: 800;\n}\n\n/* ── 설정 오류(문항 없음) ── */\n.ox-runner-error {\n  text-align: center;\n}\n\n.ox-runner .ox-error-icon {\n  font-size: 56px;\n}\n\n.ox-runner .ox-error-text {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: #b91c1c;\n}\n\n.ox-runner .ox-btn-cancel {\n  background: #059669;\n  color: #fff;\n  padding: 12px 28px;\n  font-size: 18px;\n  border-radius: 12px;\n}\n\n/* ══ OX 퀴즈 문항 화면 — Figma 3510:48255 (2026-08-12 취득) ══\n   🔴 **개정됐다.** 이전(Figma 1966:43897)은 나무판 배경 + 상단 제목/구분선/진행표시 +\n      440px O/X 대형 패널 + 좌하단 동물이었다. 개정본은 베이지 그라데이션 위에\n      제목 한 줄 · 문제 · **문항 첨부 이미지** · 하단 작은 OX 두 개뿐이다.\n      폐기한 선택자: .ox-quiz-top · -head · -kicker · -title · -body · -divider · -progress ·\n      -question · -panels · -panel-o · -panel-x · -animal · -animal-clip\n      ⚠️ 이 줄에 `panel-*` 처럼 별표+슬래시가 붙으면 **주석이 조기 종료**돼 바로 아래\n         `.ox-quiz` 규칙이 통째로 파싱에서 탈락한다(2026-08-12 실측: 브라우저 규칙 27개 중\n         `.ox-quiz` 없음 → --quiz-u 미정의 → 좌표 전멸). CSS 원문 grep 가드는 못 잡는다.\n\n   원본 프레임 1920x1200. 좌표는 --quiz-u(vw 환산)로 잡는다 — 이 화면은 1280×800 과\n   1920×1200 두 해상도를 함께 쓴다. 크기 조절은 --quiz-scale 한 줄.\n\n   🔴 배경(베이지 그라데이션)은 `.oxq-screen-beige`(OxQuizFlow.css)를 **공유**한다 —\n      화면 ②와 같은 값이라 두 군데 적으면 갈린다. 그래서 러너도 그 CSS 를 import 한다. */\n.ox-quiz {\n  --quiz-scale: 1; /* 글자 크기 조절 손잡이. 1 = Figma 원본 */\n  --quiz-u: calc(100vw / 1920 * var(--quiz-scale)); /* Figma 1px */\n\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  font-family: 'GosanjaOTF', 'Katuri', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n/* 말풍선 — Figma Union 3756:36611. 몸통 사각형 x70 y70 1780×306 + 꼬리 x1492 y376 80×80.\n   🔴 좌표는 **몸통이 아니라 자산 상자** 기준이다. 내보낸 SVG 는 드롭섀도가 사방으로\n      번져 1860×454.702 이고, 피그마 배치값(inset 좌우 -2.25% / 위 -4.27% / 아래 -17.08%)을\n      역산하면 몸통보다 좌우 40 · 위 16 · 아래 64 만큼 크다 → x30 y54 에 놓아야 몸통이\n      제자리에 온다. 몸통 좌표(70,70)에 그대로 놓으면 말풍선이 우하단으로 40px 밀린다.\n   🔴 옛 상단 고정 문구(.ox-quiz-heading)는 **이 말풍선으로 대체됐다** — 개정 노드에 그\n      텍스트 자리가 없다. 되살리면 그 자리(y60~125)가 문제 상자(y120~)와 겹친다. */\n.ox-quiz .ox-quiz-bubble {\n  position: absolute;\n  left: calc(30 * var(--quiz-u));\n  top: calc(54 * var(--quiz-u));\n  width: calc(1860 * var(--quiz-u));\n  height: calc(454.702 * var(--quiz-u));\n  background: url('../../assets/quest/ox_quiz_bubble.svg') no-repeat center / contain;\n  pointer-events: none;\n}\n\n/* 문제 — Figma 텍스트 x170 y120, 1580×206, 86px #6e4417 중앙정렬 (3756:36615).\n   바깥 프레임이 x120 폭 1680 에 좌우 패딩 50 이라 글자 상자는 x170 폭 1580 이다.\n   🔴 `Q.` 접두는 없어졌다(개정 디자인 문구에 없다).\n   🔴 글자 크기 72 는 Figma 원본 86 을 **낮춘 값**이다(2026-08-18 사용자 결정). 86 으로 그리면\n      실제 등록 문항이 상자를 넘어 자동 줄바꿈이 일어나고, 관리자가 의도한 줄 수가 어긋난다\n      (실측: '훔볼트 팽귄은…' 1830.5 > 1580). 72 에서 현재 전 문항이 약 3% 여유로 들어간다.\n      🔴 이 값은 **상한이기도 하다** — 더 긴 문항은 JS(`fitPromptFontSize`)가 더 줄인다.\n         상수 4개(폭·높이·상한·줄간격)는 JS 와 짝이며 테스트가 일치를 강제한다.\n   🔴 높이 206 은 Figma 값 그대로다. 72 기준 두 줄(172.8)은 담고 세 줄(259.2)은 담지 못한다 —\n      세로 중앙정렬이라 1줄이면 가운데 한 줄, 2줄이면 위아래로 고르게 놓인다.\n   🔴 `pre-line` 이 줄바꿈을 살린다. 빠지면 개행이 공백 한 칸으로 접혀 한 줄로 붙는다\n      (JS 의 normalizeQuestionText 와 짝 — 한쪽만 있으면 줄바꿈이 화면에 안 나온다).\n   🔴 `keep-all` 은 피그마 내보내기(break-word)와 다르게 **일부러 유지**한다 — 한글을\n      어절 중간에서 끊으면 가독성이 떨어진다. 줄 나눔은 관리자가 넣은 개행으로 통제한다. */\n.ox-quiz .ox-quiz-prompt {\n  position: absolute;\n  left: calc(170 * var(--quiz-u));\n  top: calc(120 * var(--quiz-u));\n  width: calc(1580 * var(--quiz-u));\n  height: calc(206 * var(--quiz-u));\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(72 * var(--quiz-u));\n  line-height: 1.2;\n  color: #6e4417;\n  text-align: center;\n  white-space: pre-line;\n  word-break: keep-all;\n}\n\n/* 문항 첨부 이미지 — Figma x420 y424, 1080×600.\n   `object-fit: contain` 이라 관리자가 올린 이미지 비율이 달라도 잘리지 않는다.\n   🔴 이미지가 없는 레거시 문항에서는 이 요소 자체를 렌더하지 않는다(R8). */\n.ox-quiz .ox-quiz-image {\n  position: absolute;\n  left: calc(420 * var(--quiz-u));\n  top: calc(424 * var(--quiz-u));\n  width: calc(1080 * var(--quiz-u));\n  height: calc(600 * var(--quiz-u));\n  object-fit: contain;\n}\n\n/* 마무리 화면 배경 — OX 스캔 대기 화면과 동일한 '숲' 그림(픽셀 대조 확인) */\n.ox-quiz-done {\n  background-image: url('../../assets/quest/ox_bg_1280x800.webp');\n}\n\n@media (min-width: 1600px) {\n  .ox-quiz-done {\n    background-image: url('../../assets/quest/ox_bg_1920x1200.webp');\n  }\n}\n\n/* 마무리 화면 동물 — Figma 2295:75892: 좌측 720x880 상자(세로 중앙), 안쪽 680x780 */\n.ox-quiz .ox-quiz-done-animal {\n  position: absolute;\n  left: 4.1667%; /* 80/1920 */\n  top: 50%;\n  transform: translateY(-50%);\n  width: 37.5%; /* 720/1920 */\n  height: 73.3333%; /* 880/1200 */\n  z-index: 1;\n}\n\n.ox-quiz .ox-quiz-done-animal-clip {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 94.4444%; /* 680/720 */\n  height: 88.6364%; /* 780/880 */\n  overflow: hidden;\n}\n\n/* 하단 O/X — Figma 3510:48255 의 `OX`(x860 y1044, 200×96)를 **좌=O · 우=X 2버튼**으로 쪼갰다\n   (사용자 확정 R5). 원본 자산의 글리프 실측: O = x6~727 / X = x809~1494 → 표시 중심은\n   O(909, 1092) · X(1014, 1092).\n\n   🔴 **히트박스는 시각보다 넓다.** 글리프는 96px 인데 버튼 상자는 200px 이다 —\n      어린이가 누르는 화면이라 보이는 크기로만 잡으면 헛터치가 난다.\n      `background-size` 로 그림만 원래 크기로 그리고 상자는 크게 둔다.\n   🔴 중앙정렬은 음수 마진으로 — transform 은 연출 애니메이션과 충돌한다(2026-07-31 사고). */\n.ox-quiz .ox-quiz-answers {\n  position: absolute;\n  inset: 0;\n}\n\n.ox-quiz .ox-quiz-answer {\n  position: absolute;\n  top: calc(1092 * var(--quiz-u));\n  width: calc(200 * var(--quiz-u));\n  height: calc(200 * var(--quiz-u));\n  margin: calc(-100 * var(--quiz-u)) 0 0 calc(-100 * var(--quiz-u));\n  padding: 0;\n  border: none;\n  background: transparent no-repeat center;\n  cursor: pointer;\n  transition: transform 0.08s ease-out, filter 0.08s ease-out;\n}\n\n.ox-quiz .ox-quiz-answer-o {\n  left: calc(909 * var(--quiz-u));\n  background-image: url('../../assets/quest/ox_answer_o.webp');\n  background-size: calc(96 * var(--quiz-u)) auto;\n}\n\n.ox-quiz .ox-quiz-answer-x {\n  left: calc(1014 * var(--quiz-u));\n  background-image: url('../../assets/quest/ox_answer_x.webp');\n  background-size: calc(91 * var(--quiz-u)) auto;\n}\n\n.ox-quiz .ox-quiz-answer:active:not(:disabled) {\n  transform: scale(0.9);\n}\n\n.ox-quiz .ox-quiz-answer:disabled {\n  cursor: default;\n  filter: grayscale(0.35) brightness(0.92);\n}\n\n/* 마무리 화면 동물 이미지 — `.ox-quiz-done-animal-clip` 안에서 쓴다.\n   ⚠️ 문항 화면의 좌하단 동물(`.ox-quiz-animal`/`-clip`)은 개정 디자인에 없어 폐기했다. */\n.ox-quiz .ox-quiz-animal-img {\n  position: absolute;\n  left: -8.05%;\n  top: -14.54%;\n  width: 113.24%;\n  height: 123.84%;\n  background: url('../../assets/quest/quiz_animal_toucan.webp') no-repeat center / 100% 100%;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
